import styled, { css } from 'styled-components';
import { animated, useTransition, config } from 'react-spring';

import { Emoticon } from './Emoticon';
import { TealCircle, TealRectangle, PinkTriangle } from './Decorations';

const pinkTriangleCss = css`
  left: -50px;
  width: 200px;
  bottom: 100px;

  @media screen and (min-width: 768px) {
    bottom: 0;
  }

  @media screen and (min-width: 1200px) {
    bottom: 140px;
  }
`;

const tealCircleCss = css`
  right: -53px;
  width: 120px;
  bottom: 6px;
`;

const tealRectangleCss = css`
  left: -56px;
  width: 200px;
  top: 32px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  min-height: 100%;
  color: #5734ab;
  padding: 8px;
  position: relative;
  h2 {
    text-align: center;
    font-weight: 700;
    font-size: 1.5em;
    padding: 0 32px;
  }

  @media screen and (min-height: 700px) {
    justify-content: space-evenly;
  }

  @media screen and (min-width: 920px) {
    h2 {
      font-size: 2em;
    }
  }
`;

const List = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 120px) minmax(auto, 120px);
  grid-gap: 8px;
  max-width: 900px;
  > *:first-child {
    border-top-left-radius: 16px;
  }
  > *:nth-child(2) {
    border-top-right-radius: 16px;
  }
  > *:nth-child(5) {
    border-bottom-left-radius: 16px;
  }
  > *:last-child {
    border-bottom-right-radius: 16px;
  }

  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(6, minmax(100px, 1fr));
    grid-gap: 4px;
    > *:nth-child(2) {
      border-top-right-radius: 0;
    }
    > *:nth-child(5) {
      border-bottom-left-radius: 0;
    }
    > *:first-child {
      border-top-left-radius: 16px;
      border-bottom-left-radius: 16px;
    }
    > *:last-child {
      border-top-right-radius: 16px;
      border-bottom-right-radius: 16px;
    }
  }

  @media screen and (max-width: 320px) {
    margin-bottom: 8px;
  }
`;

const ListItem = styled(animated.div)`
  text-align: center;
  background: white;
  min-height: 150px;
  padding: 12px;
  cursor: pointer;
`;

const Decorations = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;

  @media screen and (min-width: 1200px) {
    overflow: unset;
  }
`;

export const Emotions = ({ data, handleSelect }) => {
  const transitions = useTransition(data, item => item.id, {
    config: config.subtle,
    from: { opacity: 0, transform: 'translate3d(-50%, 0px, 0px)' },
    enter: { opacity: 1, transform: 'translate3d(0%, 0px, 0px)' },
    leave: { opacity: 0, height: 0, transform: 'translate3d(50%, 0px, 0px)' },
    trail: 100
  });

  const click = (i, name) => {
    // eslint-disable-next-line
    ga('WGcontent.send', 'event', 'Emotions', 'click', name);
    handleSelect(i);
  };

  return (
    <Wrapper>
      <Decorations>
        <TealRectangle styles={tealRectangleCss} />
        <TealCircle styles={tealCircleCss} />
        <PinkTriangle styles={pinkTriangleCss} />
      </Decorations>
      <h2>How are you feeling today?</h2>
      <List>
        {transitions.map(({ item, key, props }, i) => (
          <ListItem key={key} style={props} onClick={() => click(i, item.name)}>
            <Emoticon emotion={item.name} />
            {item.name}
          </ListItem>
        ))}
      </List>
    </Wrapper>
  );
};